export interface StripeTaxIdTypeOption {
  value: string;
  label: string;
}

export const STRIPE_TAX_ID_TYPES: StripeTaxIdTypeOption[] = [
  { value: 'ad_nrt', label: 'Andorra NRT' },
  { value: 'ae_trn', label: 'United Arab Emirates TRN' },
  { value: 'al_tin', label: 'Albania TIN' },
  { value: 'am_tin', label: 'Armenia TIN' },
  { value: 'ao_tin', label: 'Angola TIN' },
  { value: 'ar_cuit', label: 'Argentina CUIT' },
  { value: 'au_abn', label: 'Australia ABN' },
  { value: 'au_arn', label: 'Australia ARN' },
  { value: 'ba_tin', label: 'Bosnia and Herzegovina TIN' },
  { value: 'bd_bin', label: 'Bangladesh BIN' },
  { value: 'bg_uic', label: 'Bulgaria UIC' },
  { value: 'bh_vat', label: 'Bahrain VAT' },
  { value: 'bo_tin', label: 'Bolivia TIN' },
  { value: 'br_cnpj', label: 'Brazil CNPJ' },
  { value: 'br_cpf', label: 'Brazil CPF' },
  { value: 'ca_bn', label: 'Canada BN' },
  { value: 'ca_gst_hst', label: 'Canada GST/HST' },
  { value: 'ca_pst_bc', label: 'Canada BC PST' },
  { value: 'ca_pst_mb', label: 'Canada Manitoba PST' },
  { value: 'ca_pst_sk', label: 'Canada Saskatchewan PST' },
  { value: 'ca_qst', label: 'Canada QST' },
  { value: 'ch_uid', label: 'Switzerland UID' },
  { value: 'ch_vat', label: 'Switzerland VAT' },
  { value: 'cl_tin', label: 'Chile TIN' },
  { value: 'cn_tin', label: 'China TIN' },
  { value: 'co_nit', label: 'Colombia NIT' },
  { value: 'cr_tin', label: 'Costa Rica TIN' },
  { value: 'de_stn', label: 'Germany Tax Number' },
  { value: 'do_rcn', label: 'Dominican Republic RCN' },
  { value: 'ec_ruc', label: 'Ecuador RUC' },
  { value: 'eg_tin', label: 'Egypt TIN' },
  { value: 'es_cif', label: 'Spain CIF' },
  { value: 'eu_oss_vat', label: 'EU OSS VAT' },
  { value: 'eu_vat', label: 'European Union VAT' },
  { value: 'gb_vat', label: 'United Kingdom VAT' },
  { value: 'ge_vat', label: 'Georgia VAT' },
  { value: 'hk_br', label: 'Hong Kong BR' },
  { value: 'hr_oib', label: 'Croatia OIB' },
  { value: 'hu_tin', label: 'Hungary TIN' },
  { value: 'id_npwp', label: 'Indonesia NPWP' },
  { value: 'il_vat', label: 'Israel VAT' },
  { value: 'in_gst', label: 'India GST' },
  { value: 'is_vat', label: 'Iceland VAT' },
  { value: 'jp_cn', label: 'Japan Corporate Number' },
  { value: 'jp_rn', label: 'Japan Registered Foreign Businesses Number' },
  { value: 'jp_trn', label: 'Japan Tax Registration Number' },
  { value: 'ke_pin', label: 'Kenya PIN' },
  { value: 'kr_brn', label: 'South Korea BRN' },
  { value: 'li_uid', label: 'Liechtenstein UID' },
  { value: 'li_vat', label: 'Liechtenstein VAT' },
  { value: 'ma_vat', label: 'Morocco VAT' },
  { value: 'md_vat', label: 'Moldova VAT' },
  { value: 'me_pib', label: 'Montenegro PIB' },
  { value: 'mk_vat', label: 'North Macedonia VAT' },
  { value: 'mx_rfc', label: 'Mexico RFC' },
  { value: 'my_frp', label: 'Malaysia FRP' },
  { value: 'my_itn', label: 'Malaysia ITN' },
  { value: 'my_sst', label: 'Malaysia SST' },
  { value: 'ng_tin', label: 'Nigeria TIN' },
  { value: 'no_vat', label: 'Norway VAT' },
  { value: 'no_voec', label: 'Norway VOEC' },
  { value: 'nz_gst', label: 'New Zealand GST' },
  { value: 'om_vat', label: 'Oman VAT' },
  { value: 'pe_ruc', label: 'Peru RUC' },
  { value: 'ph_tin', label: 'Philippines TIN' },
  { value: 'ro_tin', label: 'Romania TIN' },
  { value: 'rs_pib', label: 'Serbia PIB' },
  { value: 'ru_inn', label: 'Russia INN' },
  { value: 'ru_kpp', label: 'Russia KPP' },
  { value: 'sa_vat', label: 'Saudi Arabia VAT' },
  { value: 'sg_gst', label: 'Singapore GST' },
  { value: 'sg_uen', label: 'Singapore UEN' },
  { value: 'si_tin', label: 'Slovenia TIN' },
  { value: 'sv_nit', label: 'El Salvador NIT' },
  { value: 'th_vat', label: 'Thailand VAT' },
  { value: 'tr_tin', label: 'Turkey TIN' },
  { value: 'tw_vat', label: 'Taiwan VAT' },
  { value: 'ua_vat', label: 'Ukraine VAT' },
  { value: 'us_ein', label: 'United States EIN' },
  { value: 'uy_ruc', label: 'Uruguay RUC' },
  { value: 've_rif', label: 'Venezuela RIF' },
  { value: 'vn_tin', label: 'Vietnam TIN' },
  { value: 'za_vat', label: 'South Africa VAT' },
];
